/* eslint-disable no-alert */
/* eslint-disable react/no-array-index-key */
import React, { useState } from "react";
import {
  Box,
  Typography,
  List,
  ListItem,
  ListItemText,
  Divider,
  Button,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

function AdminDashboard() {
  const navigate = useNavigate();

  // اطلاعات تستی بازیکنان
  const [players] = useState([
    {
      name: "علی احمدی",
      age: 25,
      email: "ali@example.com",
      trainingType: "دویدن",
      trainingTime: "10:00 - 11:00",
    },
    {
      name: "مریم حسینی",
      age: 22,
      email: "maryam@example.com",
      trainingType: "شنا",
      trainingTime: "14:00 - 15:00",
    },
  ]);

  // اطلاعات تستی مربیان
  const [coaches] = useState([
    {
      name: "رضا کریمی",
      email: "reza@example.com",
      trainingType: "بدنسازی",
      location: "باشگاه شماره 1",
      intensity: 4,
      time: "16:00 - 17:30",
    },
    {
      name: "سارا ملکی",
      email: "sara@example.com",
      trainingType: "دوچرخه‌سواری",
      location: "پارک لاله",
      intensity: 3,
      time: "08:00 - 09:30",
    },
  ]);

  const handleLogout = () => {
    alert("شما خارج شدید.");
    navigate("/login");
  };

  return (
    <Box
      sx={{
        padding: "20px",
        backgroundColor: "#f5f5f5",
        minHeight: "100vh",
        textAlign: "right",
      }}
    >
      <Typography variant="h4" gutterBottom>
        داشبورد ادمین
      </Typography>

      {/* بخش بازیکنان */}
      <Box sx={{ marginTop: "20px" }}>
        <Typography variant="h5" gutterBottom>
          بازیکنان
        </Typography>
        <List>
          {players.map((player, index) => (
            <ListItem key={index} sx={{ direction: "rtl" }}>
              <ListItemText
                primary={`نام: ${player.name}`}
                secondary={`ایمیل: ${player.email} | سن: ${player.age} | نوع تمرین: ${player.trainingType} | زمان تمرین: ${player.trainingTime}`}
                sx={{ textAlign: "right" }}
              />
            </ListItem>
          ))}
        </List>
      </Box>

      <Divider sx={{ margin: "20px 0" }} />

      {/* بخش مربیان */}
      <Box>
        <Typography variant="h5" gutterBottom>
          مربیان
        </Typography>
        <List>
          {coaches.map((coach, index) => (
            <ListItem key={index} sx={{ direction: "rtl" }}>
              <ListItemText
                primary={`نام: ${coach.name}`}
                secondary={`ایمیل: ${coach.email} | نوع تمرین: ${coach.trainingType} | مکان: ${coach.location} | شدت: ${coach.intensity} | زمان: ${coach.time}`}
                sx={{ textAlign: "right" }}
              />
            </ListItem>
          ))}
        </List>
      </Box>

      {/* دکمه خروج */}
      <Box sx={{ marginTop: "30px", textAlign: "center" }}>
        <Button variant="outlined" color="secondary" onClick={handleLogout}>
          خروج
        </Button>
      </Box>
    </Box>
  );
}

export default AdminDashboard;
